function ShowSucessMessage({}) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-2xl p-6 max-w-md w-11/12 sm:w-96 transform transition-all animate-fadeIn">
        <div className="flex items-start">
          <div className="bg-green-100 p-2 rounded-full mr-3 flex-shrink-0">
            <svg
              className="h-6 w-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            > 
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div> 
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              Success!
            </h3>
            <p className="text-gray-600">
              Your details have been submitted successfully. We'll get back to you shortly.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShowSucessMessage;